import JSZip from 'jszip';
import dayjs from 'dayjs';

export async function download(
  groups: { name: string; blob: Blob }[],
  zipName?: string
): Promise<void> {
  if (groups.length === 0) {
    return;
  }

  if (groups.length === 1) {
    const url = URL.createObjectURL(groups[0].blob);
    triggerDownload(url, groups[0].name);
    return;
  }

  // Multiple groups: create a zip
  const zip = new JSZip();
  groups.forEach((group) => {
    zip.file(group.name, group.blob);
  });

  const zipBlob = await zip.generateAsync({ type: 'blob' });
  const zipFilename = zipName ?? `${dayjs().format('YYYY-MM-DD')} - Aufträge.zip`;
  const url = URL.createObjectURL(zipBlob);
  triggerDownload(url, zipFilename);
}

function triggerDownload(url: string, filename: string): void {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
